// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3cwh4","label":"Category_label__2liYQ","content":"Category_content__1NTQa","header":"Category_header__3eaB7","location":"Category_location__CLCXY"};